import React from 'react';
import './Legal.css';

function Terms() {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <p className="effective-date">Effective Date: January 14, 2025</p>

        <section className="legal-section">
          <h2>Acceptance of Terms</h2>
          <p>By accessing or using our services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>
        </section>

        <section className="legal-section">
          <h2>Use of Services</h2>
          <p>You agree to use our services only for lawful purposes and in compliance with all applicable laws and regulations.</p>
          <p>You will not attempt to disrupt, alter, or misuse the services or systems provided by RiftOne.</p>
        </section>

        <section className="legal-section">
          <h2>Accounts</h2>
          <p>If you create an account with us, you are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. Notify us immediately via Discord if you suspect any unauthorized use of your account.</p>
        </section>

        <section className="legal-section">
          <h2>Refund Policy</h2>
          <p>Refunds are provided at our sole discretion. We reserve the right to approve or deny refund requests based on the circumstances of each case. If you wish to request a refund, please contact us on Discord within 24 hours of purchase.</p>
        </section>

        <section className="legal-section">
          <h2>Intellectual Property</h2>
          <p>All content, designs, software, and materials associated with our services are the property of RiftOne and are protected by applicable copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, or use any of our intellectual property without prior written consent.</p>
        </section>

        <section className="legal-section">
          <h2>Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, we are not liable for any damages, including but not limited to direct, indirect, incidental, or consequential damages, arising from your use of our services.</p>
        </section>

        <section className="legal-section">
          <h2>Termination</h2>
          <p>We reserve the right to terminate or suspend your account or access to our services at any time, for any reason, without prior notice.</p>
        </section>

        <section className="legal-section">
          <h2>Changes to Terms</h2>
          <p>We reserve the right to modify these Terms of Service at any time. Any changes will be posted on this page with the updated effective date. Continued use of our services after changes are posted constitutes your acceptance of the revised terms.</p>
        </section>

        <section className="legal-section">
          <h2>Contact</h2>
          <p>For any questions or concerns regarding these Terms of Service, please contact us on Discord at <a href="https://discord.gg/riftone" target="_blank" rel="noopener noreferrer">discord.gg/riftone</a></p>
        </section>
      </div>
    </div>
  );
}

export default Terms;